import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import validateRequestError from '../util/error/validateRequestError';

const DELETE_ACCOUNT_TOKEN = gql`
  mutation DeleteAccountToken($id: String!) {
    deleteAccountToken(id: $id)
  }
`;

export const useDeleteAccountToken = () => {
  const [deleteAccountToken] = useMutation(DELETE_ACCOUNT_TOKEN);

  const deleteAccount = async (id: string) => validateRequestError(await deleteAccountToken({variables: {id}}));

  return deleteAccount;
};
